import React, { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

import Pagination from '@/compoments/common/Pagination'
import PageLoader from '@/compoments/PageLoader'
import { useGetTechnicianPerfomanceQuery } from '@/services/executives/executives'
import type { TechnicianPerformanceQueryParams } from '@/services/executives/response.interface'

import Filters from './components/Filters'
import Table from './components/Table'

const ExecutivesTechnicianPerformancePage = () => {
    const [searchParams, setSearchParams] = useSearchParams()

    const params = useMemo(
        () =>
            ({
                page: +(searchParams.get('page') || 1),
                rating: searchParams.get('rating'),
                skills: searchParams.get('skills'),
                certificates: searchParams.get('certificates'),
                status: searchParams.get('status'),
                job_completed: searchParams.get('job_completed'),
            }) as TechnicianPerformanceQueryParams,
        [searchParams],
    )
    const { data, isLoading } = useGetTechnicianPerfomanceQuery(params)
    const pageData = data?.data

    if (isLoading) return <PageLoader />
    return (
        <main className="content">
            <div className="px-container">
                <div className="table-group">
                    <div className="table-header flex items-center justify-between">
                        <Filters />
                    </div>
                    <div className="table-body table-responsive p-0">
                        <Table data={pageData} />
                    </div>
                </div>
                <Pagination pagination={data?.pagination} />
            </div>
        </main>
    )
}

export default ExecutivesTechnicianPerformancePage
